export default {
      id: "i-how-work-zpif-usage",
      viewBox: "0 0 20 19",
      url: __webpack_public_path__ + "img/sprite.svg#i-how-work-zpif",
      toString: function () {
        return this.url;
      }
    }